import { createFileRoute } from "@tanstack/react-router";
import { CompliancePulse } from "@/components/CompliancePulse/CompliancePulse";

export const Route = createFileRoute("/_authenticated/pulse/compliance/")({
  component: CompliancePulse,
  staticData: { page: "engineering" },
});
